import { LoginToRapnetModalForm } from "./login-to-rapnet-modal.types";

export const loginToRapnetModalForm: LoginToRapnetModalForm = {
  accountId: "",
};
